import { SSE } from 'sse.js';
import webConfig from '../utils/httpUrlConfig';

export interface FetchLLMAnswerReqParams {
  askContent: string;
  uuid: string;
  token: string;
  historyId?: number;
  messageCallback?: (data: any, id: any) => void;
  errorCallback?: (err: string) => void;
  startCallback?: () => void;
  finishCallback?: (id: any) => void;
  loadingCallback?: (isLoading: boolean) => void;
}

export const fetchLLMAnswer = async (params: FetchLLMAnswerReqParams) => {
  try {
    let startFlag = false;
    let id = 0;
    params.loadingCallback?.(true);
    const payload = {
      prompt: params.askContent,
      topic: params.uuid,
      dialogueSource: 'DTS',
    };

    const sse = new SSE(`${webConfig.apiUrl}/assistant/front/chat`, {
      method: 'POST',
      headers: {
        'X-Token': params.token,
        'Content-Type': 'application/JSON',
      },
      payload: JSON.stringify(payload),
    });

    params?.startCallback?.();

    sse.addEventListener('answer', (e) => {
      try {
        const data = JSON.parse(e.data || '{}');
        console.info('data--->', e);
        // !startFlag && params?.startCallback?.();
        startFlag = true;
        if (id === 0) {
          id = e.id;
        }
        if (data?.answer || data?.hyperlink) {
          params?.messageCallback?.({ ...data, ...params }, e.id);
        } else {
          const res = JSON.parse(sse.xhr?.response || '{}');
          if (['401', '403', '405'].includes(res.status)) {
            console.error(res);
          }
        }
      } catch (error) {
        console.error(error);
        console.error(e);
        console.error(sse);
      }
    });

    sse.addEventListener('error', (e) => {
      try {
        const data = JSON.parse(e.data || '{}');
        if (data?.message) {
          params?.errorCallback?.(data.message);
        }
      } catch (error) {
        params?.errorCallback?.('Bad response Status Code');
        console.error(error);
      }
    });

    sse.addEventListener('readystatechange', (e) => {
      if (e.readyState === 2) {
        params?.finishCallback?.(id);
        params.loadingCallback?.(false);
        startFlag = false;
      }
    });

    sse.stream();
  } catch (e) {
    console.error(e);
  }
};
